import React, { Component } from 'react'
import {Link} from 'react-router'
import './HomeBanner.scss'
import HomeLogin from '../HomeLogin'

class HomeBanner extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div className='home-banner'>

              {this.props.location === 'login' &&
                <div className='container center-vertical'>
                  <HomeLogin location={this.props.location} notify={this.props.notify} />
                </div>
              }

              {this.props.location === 'register' &&
                <div className='container center-vertical'>
                  <HomeLogin location={this.props.location} />
                </div>
              }

              {this.props.location === '/' &&
                <div className='container center-vertical'>
                  <h1><strong>Pro</strong>Quotes</h1>
                  <p>&nbsp;{this.props.description}</p>
                  &nbsp;<Link to='register' className="btn btn-info btn-lg">{this.props.cta}</Link>
                </div>
              }
              {this.props.location === '/' &&
                <div className='welcome-thumb'>
                  <img src={'assets/new-phone.png'} alt=""/>
                </div>
              }


            </div>
        )
    }
}

export default HomeBanner



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeBanner/index.js